import { sharedAtom } from '../utilities/jotai-utils';

export const permissions = sharedAtom('global_permissions', {
  /** this is how the permission map object will look like
  customer_id: {
    'account.features.read': true,
    ...
    'users.write': true
  }
  */
});

export const permissionsMetaData = sharedAtom('global_permissionsMeta', {
  /** this is how the meta-data object will look like
  customer_id: {
    loading: true,
    error: ...
  }
  */
});
